var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: { form: _vm.form, rules: _vm.rules, "label-width": "140px" },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("SubordinateCompanies.Form.Name"),
            prop: "orgName",
          },
        },
        [
          _c("BjInput", {
            attrs: {
              maxlength: _vm.MAX_LENGTH.DEFAULT,
              placeholder: _vm.$t("inputText"),
            },
            model: {
              value: _vm.form.orgName,
              callback: function ($$v) {
                _vm.$set(_vm.form, "orgName", $$v)
              },
              expression: "form.orgName",
            },
          }),
        ],
        1
      ),
      _c("BjFormItemCode", {
        attrs: {
          readonly: _vm.isEdit,
          label: _vm.$t("SubordinateCompanies.Form.CompanyCode"),
          prop: "orgCode",
        },
        model: {
          value: _vm.form.orgCode,
          callback: function ($$v) {
            _vm.$set(_vm.form, "orgCode", $$v)
          },
          expression: "form.orgCode",
        },
      }),
      _c(
        "el-form-item",
        { attrs: { label: _vm.$t("SubordinateCompanies.Form.Group") } },
        [_vm._v(" " + _vm._s(_vm.group.groupName) + " ")]
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("SubordinateCompanies.Form.ParentCompany"),
            prop: "pid",
          },
        },
        [
          _c("BjCompanyTreeSelect", {
            attrs: { placeholder: _vm.$t("chooseText") },
            model: {
              value: _vm.form.pid,
              callback: function ($$v) {
                _vm.$set(_vm.form, "pid", $$v)
              },
              expression: "form.pid",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("SubordinateCompanies.Form.LegalPerson"),
            prop: "legalPerson",
          },
        },
        [
          _c("BjInput", {
            attrs: {
              maxlength: _vm.MAX_LENGTH.DEFAULT,
              placeholder: _vm.$t("inputText"),
            },
            model: {
              value: _vm.form.legalPerson,
              callback: function ($$v) {
                _vm.$set(_vm.form, "legalPerson", $$v)
              },
              expression: "form.legalPerson",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("SubordinateCompanies.Form.UnifiedSocialCreditCode"),
            prop: "uniformSocialCreditCode",
          },
        },
        [
          _c("BjInput", {
            attrs: {
              maxlength: _vm.MAX_LENGTH.DEFAULT,
              placeholder: _vm.$t("inputText"),
            },
            model: {
              value: _vm.form.uniformSocialCreditCode,
              callback: function ($$v) {
                _vm.$set(_vm.form, "uniformSocialCreditCode", $$v)
              },
              expression: "form.uniformSocialCreditCode",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("SubordinateCompanies.Form.PictureOfBusinessLicense"),
            prop: "businessLicense",
          },
        },
        [
          _c(
            "BjUpload",
            {
              ref: "upload",
              staticClass: "avatar-uploader",
              attrs: {
                "auto-upload": "",
                accept: "image/png,image/jpeg",
                "accept-list": ["image/jpeg", "image/png"],
                "limit-size": 2048,
              },
              on: { afterUpload: _vm.afterUpload },
            },
            [
              _c(
                "template",
                { slot: "default" },
                [
                  _vm.form.businessLicense
                    ? _c("BjKeyImage", {
                        staticClass: "avatar",
                        attrs: { url: _vm.form.businessLicense },
                      })
                    : _c("i", {
                        staticClass: "el-icon-plus avatar-uploader-icon",
                      }),
                ],
                1
              ),
              _c("template", { slot: "tip" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("SubordinateCompanies.Form.ps")) + " "
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }